<form [formGroup]="form">
    <input type="range" 
           class="slider" 
           #slider 
           formControlName="tip" 
           [min]="minValue"
           [max]="maxValue" />
</form>